export const TitleEnum = {
  Error: 'Error',
  Warning: 'Warning',
  Report: 'Report',
  Success: 'Success',
};

export const GenericEnum = {
  EmptyString: '',
  ZeroString: '0',
  InitialFilterValue: 0,
};

export const PrintOptionsEnum = {
  ItemCode: 'ItemCode',
  ItemDescription: 'ItemDescription',
};

export const PrintSortTypeEnum = {
  ItemCode: 0,
  ItemDescription: 1,
};

export const DropDownEnum = {
  EmptyString: '',
  NullValue: null,
};

export const FileDownloadTypes = {
  CSV: 'text/csv',
  Excel: 'application/vnd.ms-excel',
  Txt: 'text/plain',
  OCTETStream: 'application/octet-stream',
  ExcelOpenXML:
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
};

export const TypeOfDropDownEnum = {
  AllOnly: 0,
  UnassignedAndAll: 1,
  UnassignedOnly: 2,
  Nothing: 3,
};

export const PrintGroupByTypeEnum = {
  Item: 0,
  Site: 1,
};

export const ActiveStatusEnum = {
  Active: 'A',
  Inactive: 'I',
};

export const ReportTypeEnum = {
  OrderReport: 0,
  PhysicalInventoryReport: 1,
};

export const OrderTransactionTypesEnum = {
  Adjustment: 'A',
  Order: 'O',
  Physical: 'P',
  Receipt: 'R',
  Transfer: 'T',
  Usage: 'U',
};

export const PrintItemActiveStatusEnum = {
  Active: 0,
  Inactive: 1,
};

export const QuantityConstantsEnum = {
  OneQuarterNumeric: '0.2500',
  OneQuarterRational: '1/4',
  OneThirdNumeric: '0.3333',
  OneThirdRational: '1/3',
  OneHalfNumeric: '0.5000',
  OneHalfRational: '1/2',
  TwoThirdsNumeric: '0.6667',
  TwoThirdsRational: '2/3',
  ThreeQuartersNumeric: '0.7500',
  ThreeQuartersRational: '3/4',
};
export const CreateEditPageEnum = { NEW: '0', EDIT: '1' };



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/CommonEnum.js